import React from "react";
import { connect } from "react-redux";
import {
  Transition,
  Container,
  Header,
  Segment,
  Button
} from "semantic-ui-react";
import AlumnoForm from "./shared/alumnos/AlumnoForm";
import { alumnosOps } from "../ducks/alumnos";

class NuevoAlumno extends React.Component {
  state = { visible: false };

  componentDidMount() {
    this.setState({ visible: true });
  }

  handleVolver = () => this.props.history.goBack();

  render() {
    return (
      <Transition.Group animation="scale" duration={250}>
        {this.state.visible && (
          <Container>
            <Segment basic>
              <Segment basic>
                <Button
                  content="Cerrar"
                  floated="right"
                  color="pink"
                  icon="cancel"
                  onClick={this.handleVolver}
                />
                <Header inverted as="h2" textAlign="center">
                  Nuevo Alumno
                </Header>
              </Segment>
              <AlumnoForm action={this.props.saveDataAlumno} />
            </Segment>
          </Container>
        )}
      </Transition.Group>
    );
  }
}

const mapStateToProps = state => ({});
const actions = {
  saveDataAlumno: alumnosOps.saveDataAlumno
};

export default connect(mapStateToProps, actions)(NuevoAlumno);



// WEBPACK FOOTER //
// ./src/pages/NuevoAlumno.jsx